const FALLBACK_TITLE = 'Package';
const FALLBACK_DESCRIPTION = 'Trip details from Nexgo.';
const DESCRIPTION_MAX_LENGTH = 200;

const trimValue = (value?: string | null): string => (value || '').trim();

export const sanitizeTitle = (value?: string | null): string => {
  const title = trimValue(value);
  return title || FALLBACK_TITLE;
};

export const sanitizeDescription = (value?: string | null): string => {
  const description = trimValue(value) || FALLBACK_DESCRIPTION;
  if (description.length <= DESCRIPTION_MAX_LENGTH) {
    return description;
  }

  return `${description.slice(0, DESCRIPTION_MAX_LENGTH - 1).trimEnd()}…`;
};

export const normalizeBaseUrl = (value?: string | null): string => {
  return trimValue(value).replace(/\/+$/, '');
};

const isHttpUrl = (value?: string | null): boolean => {
  if (!value) return false;
  try {
    const parsed = new URL(value);
    return parsed.protocol === 'http:' || parsed.protocol === 'https:';
  } catch {
    return false;
  }
};

export const resolveFrontendBaseUrl = (): string => {
  const envBase = normalizeBaseUrl(
    process.env.NEXT_PUBLIC_FRONTEND_URL || process.env.NEXT_PUBLIC_APP_URL
  );
  if (envBase) {
    return envBase;
  }

  if (typeof window !== 'undefined') {
    return normalizeBaseUrl(window.location.origin);
  }

  return '';
};

export const toAbsoluteUrl = (pathOrUrl: string, baseUrl?: string): string => {
  const input = trimValue(pathOrUrl);
  if (!input) return '';
  if (isHttpUrl(input)) return input;

  const resolvedBase = normalizeBaseUrl(baseUrl || resolveFrontendBaseUrl());
  if (!resolvedBase) return '';
  const normalizedPath = input.startsWith('/') ? input : `/${input}`;
  return `${resolvedBase}${normalizedPath}`;
};

export const getSafeImageUrl = (value?: string | null): string | undefined => {
  const trimmed = trimValue(value);
  if (!trimmed) return undefined;
  const absolute = toAbsoluteUrl(trimmed);
  return isHttpUrl(absolute) ? absolute : undefined;
};
